import { Component, OnInit } from '@angular/core';
import { CalendarShared } from '../../general/shared/calendar-shared';
import * as moment from 'jalali-moment';
import { DateHelper } from 'src/app/utils/date-helper';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  title: string;
  weekDaysTitle = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];
  days = [];
  calendarToday: string;
  selectedMonth: string;
  selectedYear: string;

  constructor(
    private calendarShared: CalendarShared,
    private dateHelper: DateHelper,
    private diaryAnalytics: DiaryAnalyticsService
  ) {
    this.selectedMonth = moment(this.calendarShared.selectedDate).format('jMM');
    this.selectedYear = moment(this.calendarShared.selectedDate).format(
      'jYYYY'
    );
    this.prepareCalendar();
  }

  ngOnInit() {
    setTimeout(() => {
      document.getElementById('calendar').style.top = '0';
    }, 10);
    document
      .getElementById('calendar')
      .addEventListener('click', (e) => e.stopPropagation());
  }

  closeCalendar() {
    document.getElementById('calendar').style.top = '-400px';
    setTimeout(() => {
      this.calendarShared.closeCalendar();
    }, 300);
  }

  prepareCalendar() {
    this.title =
      this.dateHelper.getPersianMonthNameByMonthNumber(this.selectedMonth) +
      ' ' +
      this.selectedYear;
    if (
      this.selectedMonth ===
        moment(this.calendarShared.selectedDate).format('jMM') &&
      this.selectedYear ===
        moment(this.calendarShared.selectedDate).format('jYYYY')
    ) {
      this.calendarToday = moment(this.calendarShared.selectedDate).format(
        'jDD'
      );
    } else {
      this.calendarToday = '';
    }
    this.prepareCalendarDays();
  }

  prepareCalendarDays() {
    this.days = [];
    const d = this.selectedYear + '/' + this.selectedMonth + '/' + '1';
    const jalali = moment.from(d, 'fa', 'YYYY/MM/DD');
    const calendarStartDay = (jalali.day() + 1) % 7;
    const max =
      this.dateHelper.getPersianMonthMaximumDay(
        this.selectedMonth,
        this.selectedYear
      ) + calendarStartDay;
    for (let i = 0; i < max; i++) {
      if (i < calendarStartDay) {
        this.days[i] = -1;
      } else {
        this.days[i] = i + 1 - calendarStartDay;
      }
    }
  }

  nextMonth() {
    if (parseInt(this.selectedMonth) < 9) {
      this.selectedMonth = '0' + (parseInt(this.selectedMonth) + 1).toString();
    } else if (parseInt(this.selectedMonth) < 12) {
      this.selectedMonth = (parseInt(this.selectedMonth) + 1).toString();
    } else {
      this.selectedMonth = '01';
      this.selectedYear = (parseInt(this.selectedYear) + 1).toString();
    }
    this.prepareCalendar();
  }

  previousMonth() {
    if (parseInt(this.selectedMonth) > 10) {
      this.selectedMonth = (parseInt(this.selectedMonth) - 1).toString();
    } else if (parseInt(this.selectedMonth) > 1) {
      this.selectedMonth = '0' + (parseInt(this.selectedMonth) - 1).toString();
    } else {
      this.selectedMonth = '12';
      this.selectedYear = (parseInt(this.selectedYear) - 1).toString();
    }
    this.prepareCalendar();
  }

  selectDay(day: number) {
    if (day >= 1) {
      this.diaryAnalytics.analyticDiaryDateChanged();
      const d =
        this.selectedYear + '/' + this.selectedMonth + '/' + day.toString();
      const jalali = moment.from(d, 'fa', 'YYYY/MM/DD');
      // console.log(new Date(jalali.year(), jalali.month(), jalali.date()))
      this.calendarShared.selectedDate = new Date(
        jalali.year(),
        jalali.month(),
        jalali.date(),
        0,
        0,
        1,
        0
      );
      this.closeCalendar();
    }
  }

  selectToday() {
    this.diaryAnalytics.analyticDiaryDateChanged();
    this.calendarShared.selectedDate = new Date(
      new Date().setHours(0, 0, 1, 0)
    );
    this.closeCalendar();
  }
}
